export const LOAD_ALL_ITEMS = 'LOAD_ALL_ITEMS'
export const LOAD_ALL_CUSTOMER_ITEMS = 'LOAD_ALL_CUSTOMER_ITEMS'
export const LOAD_ALL_ITEMS_USED = 'LOAD_ALL_ITEMS_USED'
export const LOAD_ALL_SOFTWARE_ITEMS = 'LOAD_ALL_SOFTWARE_ITEMS'
